/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmsatzVerteilung
 */
export interface UmsatzVerteilung {
    /**
     * 
     * @type {number}
     * @memberof UmsatzVerteilung
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzVerteilung
     */
    idPrognoseGruppe: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzVerteilung
     */
    idFirma: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzVerteilung
     */
    prozent: number;
}

/**
 * Check if a given object implements the UmsatzVerteilung interface.
 */
export function instanceOfUmsatzVerteilung(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "idPrognoseGruppe" in value;
    isInstance = isInstance && "idFirma" in value;
    isInstance = isInstance && "prozent" in value;

    return isInstance;
}

export function UmsatzVerteilungFromJSON(json: any): UmsatzVerteilung {
    return UmsatzVerteilungFromJSONTyped(json, false);
}

export function UmsatzVerteilungFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmsatzVerteilung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idPrognoseGruppe': json['idPrognoseGruppe'],
        'idFirma': json['idFirma'],
        'prozent': json['prozent'],
    };
}

export function UmsatzVerteilungToJSON(value?: UmsatzVerteilung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idPrognoseGruppe': value.idPrognoseGruppe,
        'idFirma': value.idFirma,
        'prozent': value.prozent,
    };
}

